import { forwardRef } from 'react';

import { IconProps } from '.';

export const CalendarBlankIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.25 3.02631C6.83579 3.02631 6.5 3.36209 6.5 3.77631V4.52631H5.25C4.00736 4.52631 3 5.53367 3 6.77631V16.2763C3 17.5189 4.00736 18.5263 5.25 18.5263H14.75C15.9926 18.5263 17 17.5189 17 16.2763V6.77631C17 5.53367 15.9926 4.52631 14.75 4.52631H13.5V3.77631C13.5 3.36209 13.1642 3.02631 12.75 3.02631C12.3358 3.02631 12 3.36209 12 3.77631V4.52631H8V3.77631C8 3.36209 7.66421 3.02631 7.25 3.02631ZM12 6.77631V6.02631H8V6.77631C8 7.19052 7.66421 7.52631 7.25 7.52631C6.83579 7.52631 6.5 7.19052 6.5 6.77631V6.02631H5.25C4.83579 6.02631 4.5 6.36209 4.5 6.77631V9.02631H15.5V6.77631C15.5 6.36209 15.1642 6.02631 14.75 6.02631H13.5V6.77631C13.5 7.19052 13.1642 7.52631 12.75 7.52631C12.3358 7.52631 12 7.19052 12 6.77631ZM15.5 10.5263H4.5V16.2763C4.5 16.6905 4.83579 17.0263 5.25 17.0263H14.75C15.1642 17.0263 15.5 16.6905 15.5 16.2763V10.5263Z"
      />
    </svg>
  );
});

export default CalendarBlankIcon;
